/* eslint-disable no-unused-vars, @typescript-eslint/no-unused-vars */
/* global __webpack_public_path__ */

// eslint-disable-next-line no-global-assign
__webpack_public_path__ = `${Gaia.staticURL}js/bundles/`;

// We aspire for GaiaCloud to support every browser supported by Mapbox GL JS
// https://docs.mapbox.com/help/troubleshooting/mapbox-browser-support/#mapbox-gl-js

// https://caniuse.com/#feat=promises
import {polyfill} from 'es6-promise';
polyfill();

// https://caniuse.com/#feat=mdn-javascript_builtins_symbol_asynciterator
import 'es6-symbol/implement';

// https://caniuse.com/#search=asynciterator
if (Symbol['asyncIterator'] === undefined) {
    Symbol.asyncIterator = Symbol.for('asyncIterator');
}

// We call `window.trackAnalytics` in some html templates
import trackAnalytics from '../utils/gaia/trackAnalytics';
import {trackFormAnalytics, trackRevenueAnalytics} from '../utils/gaia/trackAnalytics';
window.trackAnalytics = trackAnalytics;
window.trackFormAnalytics = trackFormAnalytics;
window.trackRevenueAnalytics = trackRevenueAnalytics;
